import { useContext, useState } from 'react';
import { StandardizedInvoice } from '../../../../../../typings/Orb.interface';
import { useToasts } from '../../../../../common/Toast';
import { GlobalContext } from '../../../../../contexts/GlobalContext';
const useRetryInvoicePayment = (on_retried?: () => void | Promise<void>) => {
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    addToast
  } = useToasts();
  const [retrying_invoice_id, setRetryingInvoiceId] = useState<string>();
  const retryInvoicePayment = async (invoice: StandardizedInvoice) => {
    if (!invoice.orb_id || retrying_invoice_id) {
      return;
    }
    try {
      setRetryingInvoiceId(invoice.orb_id);
      await HookdeckAPI.billing.retryInvoicePayment(invoice.orb_id);
      addToast('success', 'Payment retry initiated. It can take a few minutes to process.');
      await on_retried?.();
    } catch (error: any) {
      addToast('error', error?.response?.message || 'Failed to retry payment');
    } finally {
      setRetryingInvoiceId(undefined);
    }
  };
  return {
    retryInvoicePayment,
    retrying_invoice_id
  };
};
export default useRetryInvoicePayment;